import { CognitoOTPAuthContext } from 'cognito/CognitoOTPAuthContext';
import Button from 'components/Button';
import React, { useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import LoadingSpinner from 'components/LoadingSpinner/LoadingSpinner';

const NotFound: React.FC = () => {
  const history = useHistory();
  const { isAuthenticated, isInitialized } = useContext(CognitoOTPAuthContext);

  useEffect(() => {
    if (!isInitialized) return; // Wait for initialization before checking auth status

    if (!isAuthenticated) {
      // If not logged in, redirect to login page
      history.replace('/login');
      return; // Render nothing while redirecting
    }
  }, [isAuthenticated, isInitialized, history]);

  if (!isInitialized) {
    return <LoadingSpinner />; // Optional loading state while checking auth status
  }

  return (
    <div className='text-center mt-5'>
      <h1>404 - Not Found</h1>
      <p>The page you are looking for does not exist.</p>
      <div className='d-flex justify-content-center'>
        <div className='m-3'>
          <Button outline onClick={() => history.goBack()} text='Go Back' />
        </div>
        <div className='m-3'>
          <Button outline onClick={() => history.push('/')} text="Go to Home" />
        </div>
      </div>
    </div>
  );
};

export default NotFound;